<template>
    <div>

    </div>
</template>

<script>
    export default {
        name: "Logout",
        created() {
            localStorage.removeItem('auth-token');
            this.$router.push('/login');
        }
    }
</script>
